<template>
    <!--Waiting List Transactions Page-->
    <div class="waiting-list-transactions">
        <!--Heading title-->
        <h3>{{ $ml.get("waitingListTransactions.title") }}</h3>
        <div class="section-wrap">
            <div class="wlist-transactions-wrap" v-if="!loading">
                <div class="wlist-transactions section-wrap">
                    <h5>Transactions</h5>
                    <table id="transactions">
                        <tr>
                            <th>Payment Date</th>
                            <th>Paid Amount</th>
                            <th class="hide-element">Event Type</th>
                        </tr>
                        <tr v-for="transaction in transactions" :key="transaction.id">
                            <td>{{ getFormattedDate(transaction.created_at, "MMM DD, YYYY, h:mm A") }}</td>
                            <td>
                                {{ profileCurrency }}{{ transaction.amount }}
                            </td>
                            <td class="hide-element">{{ returnTypeText(transaction.event_type) }}</td>
                        </tr>

                    </table>
                    <div class="load-more-wrap" v-if="totalTransactions > limit">
                        <button class="primary-btn extra-small mobile" @click="loadMore">Load more</button>
                    </div>
                </div>
                <div class="wlist-cards">
                    <listing-cards :waitingList="1"></listing-cards>
                </div>
                <!--Back to Dashboard-->
                <div class="back-btn-wrap">
                    <router-link class="primary-btn extra-small mobile" :to="{ path: '/app/waiting-list/dashboard' }">
                        {{ $ml.get("general.goBack") }}
                    </router-link>
                </div>
            </div>
            <main-loader v-if="loading"></main-loader>
        </div>

    </div>
</template>

<script>
import ListingCards from '../../admin/general-components/listing_cards.vue';
import api from "../../../services/api_endpoints";
import moment from "moment";
import MainLoader from '../general-components/main_loader.vue';
import store from '../../../services/vuex';
import eventBus from '../../../services/event_bus';

export default {
    data() {
        return {
            transactions: {},
            offset: 0,
            limit: 10,
            loading: false,
            profileCurrency: '$',
            profile: {},
            loadingCurrency: false,
            totalTransactions: 0,
        };
    },
    computed: {
        adminDetails: {
            get: function () {
                return store.state.adminDetails;
            },
            set: function (value) {
                store.commit("setAdminDetails", value);
            },
        },
    },
    mounted() {
        this.getWaitingListSubscriptionTransactions()

        if (store.state.adminDetails.profile != undefined) {
            this.getStylistProfile();
        }
        let self = this;
        eventBus.$on("admin_details_loaded", function () {
            self.getStylistProfile();
        });
    },
    components: {
        ListingCards,
        MainLoader,
    },
    methods: {
        getWaitingListSubscriptionTransactions() {
            this.loading = true;

            this.$http.get(api.actions.get_waitlist_transactions + "?offset=" + this.offset + "&limit=" + this.limit).then((response) => {

                if (response.data.error == true) {
                    return;
                }

                this.transactions = response.data.transactions;
                this.totalTransactions = response.data.total;
                this.loading = false;
            });
            return;
        },
        getFormattedDate(date, format) {
            return moment(date).format(format);
        },
        returnTypeText(type) {
            let typeText = '';

            if (type === "trial_started") {
                typeText = "Trial started";
            } else if (type === "subscription_went_active") {
                typeText = "Subscription went active";
            } else if (type === "subscription_charged_successfully") {
                typeText = "Subscription charged successfully";
            } else if (type === "subscription_canceled") {
                typeText = "Subscription canceled";
            }

            return typeText;
        },
        getStylistProfile() {
            this.loadingCurrency = true;
            this.profile = this.adminDetails.profile;
        },
        loadMore() {
            if (this.totalTransactions < this.limit) {
                return;
            }

            this.limit = this.limit + 10;
            this.getWaitingListSubscriptionTransactions();
        },
    },
}
</script>
